import React from 'react';
import Ellipse from '@splunk/dashboard-visualizations/Ellipse';

export default () => <Ellipse options={{ strokeWidth: 5, strokeOpacity: 0.5 }} />;
